import { format, isBefore, isSameDay, isSameHour } from 'date-fns';

import { useI18n } from '@/plugins/i18n';

const { t } = useI18n();

export function paymentDateDisplayFormat(date: string | Date, isY2Y: boolean): string {
  const now = new Date();
  const d = new Date(date);

  if (isSameDay(d, now)) {
    return isY2Y && (isSameHour(d, now) || isBefore(d, now)) ? t('dict.instant') : t('dict.today');
  }
  return format(d, 'dd.MM.yyyy');
}
